"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchUploads = exports.uploadFile = exports.getUploadUrlFromFile = void 0;
var Config_1 = require("../Config");
var ApiUtil_1 = require("../Utils/ApiUtil");
function getUploadUrlFromFile(file, options) {
  var _a;
  if (options === void 0) {
    options = {};
  }
  return __awaiter(this, void 0, void 0, function () {
    var fileKey, fileType, _b, acl, token, _token;
    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          fileKey = file.name.split('.')[0];
          fileType = file.type;
          _b = options.acl, acl = _b === void 0 ? 'public-read' : _b, token = options.token;
          _token = token || ((_a = Config_1.get().UserOutlet.getValue()) === null || _a === void 0 ? void 0 : _a.token);
          return [4 /*yield*/, ApiUtil_1.req(Config_1.get().storageHost + "/storage/presigned/url?client_id=" + Config_1.get().clientId + (_token ? '&token=' + _token : ''), {
            method: 'POST',
            data: {
              acl: acl,
              'Content-Type': fileType,
              key: "" + fileKey
            }
          })];
        case 1:
          return [2 /*return*/, _c.sent()];
      }
    });
  });
}
exports.getUploadUrlFromFile = getUploadUrlFromFile;
function uploadFile(destUrl, formData) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, fetch(destUrl, {
            method: 'POST',
            headers: {},
            body: formData
          })];
        case 1:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
}
exports.uploadFile = uploadFile;
function fetchUploads(data, options) {
  var _a;
  if (data === void 0) {
    data = {};
  }
  if (options === void 0) {
    options = {
      anonymous: false,
      token: ''
    };
  }
  return __awaiter(this, void 0, void 0, function () {
    var params, queryString;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          params = {
            client_id: Config_1.get().clientId
          };
          if (!options.anonymous && (options.token || ((_a = Config_1.get().UserOutlet.getValue()) === null || _a === void 0 ? void 0 : _a.token))) {
            params.token = options.token || Config_1.get().UserOutlet.getValue().token;
          }
          queryString = Object.keys(params).map(function (key) {
            return key + "=" + params[key];
          }).join('&');
          return [4 /*yield*/, ApiUtil_1.req(Config_1.get().storageHost + "/storage/file/list?" + queryString, {
            method: 'POST',
            data: data
          })];
        case 1:
          return [2 /*return*/, _b.sent()];
      }
    });
  });
}
exports.fetchUploads = fetchUploads;